import { atomWithReset } from 'jotai/utils'

import { type DocumentImage } from './hooks/useFetchDocumentImages'

export const searchWordAtom = atomWithReset('')
export const showAllAtom = atomWithReset(true)

type DialogInfo = {
  dialogType: 'update'
  documentImage: DocumentImage
}

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
